// extracted by mini-css-extract-plugin
module.exports = {"bootstrap-panel":"style_bootstrap-panel__1wyp9","display-flex":"style_display-flex__117D4","link-text":"style_link-text__1lLhu"};